module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/06-f8180670334623efb411354ab6b41de2.jpg";